// src/components/profile/ProfilePicture.js
import React from 'react';
import { SocialLinks } from './SocialLinks';
import styles from '../../styles/pages/About.module.css';

/**
 * Displays profile picture with optional social links
 * 
 * @param {Object} props - Component props
 * @param {string} [props.imgSrc="/headshot.jpeg"] - Image source path, null for no image
 * @param {string} [props.altText="Profile"] - Image alt text
 * @param {boolean} [props.showSocialLinks=true] - Whether to show social links
 */
export function ProfilePicture({
  imgSrc = "/headshot.jpeg",
  altText = "Nick Debeurre", 
  showSocialLinks = true
}) {
  return (
    <div className={styles.profilePictureContainer}>
      {imgSrc && (
        <img
          src={imgSrc}
          alt={altText}
          className={styles.profileImage}
          onError={(e) => {
            console.error("Error loading image:", e);
            e.target.onerror = null;
            e.target.src = "https://via.placeholder.com/250?text=Profile+Image";
          }}
        />
      )}
      {showSocialLinks && <SocialLinks />}
    </div>
  );
}